import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fallbackProfile = {
  name: "Apprenticewala",
  address: "",
  phone: "",
  email: "",
  website: "",
  header_logo_url: "",
  whatsapp_channel_link: "",
};

export default function useCompanyProfile() {
  const [profile, setProfile] = useState(fallbackProfile);

  useEffect(() => {
    fetch(`${API}/company/profile`)
      .then((response) => response.ok ? response.json() : fallbackProfile)
      .then((data) => setProfile({ ...fallbackProfile, ...data }))
      .catch(() => setProfile(fallbackProfile));
  }, []);

  return profile;
}